import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import Storage from '@/found/utils/storage';
import selectArea from './components/selectArea.vue';
import selectCompany from './components/selectCompany.vue';
import selectCus from './components/selectCus.vue';
import proDetails from './components/productTable.vue';

formCreate.component('selectArea', selectArea);
formCreate.component('selectCompany', selectCompany);
formCreate.component('selectCus', selectCus);
formCreate.component('proDetails', proDetails);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      buttons: {
        submitAudit: true,
      },
      buttonText: {
        submitAudit: '暂存',
      },
      formFunctionCode: 'main_form',
    };
  },
  async created() {
    await this.getFormRule('main_form', 'CRM20250626000000003');
  },
  methods: {
    // 设置规则
    setRule(item) {
      const rowData = item;
      console.log(rowData);
      if (rowData.field === 'fileList') {
        rowData.props = {
          ...rowData.props,
          showFileList: true,
          uploadType: 'file',
          listType: 'text',
          fileMsg: '只能上传png/jpg文件',
          accept: '.png,.jpg',
        };
      }
      if (rowData.field === 'personType') {
        rowData.props = {
          ...item.props,
          clearable: false,
        };
        rowData.on = {
          ...rowData.on,
          change: (e) => {
            console.log('eee', e);
            this.judgeHidden(e);
          },
        };
      }
      if (rowData.field === 'regionName') {
        rowData.props = {
          ...item.props,
          getValue: (field) => this.getFieldValue(field),
          title: rowData.title,
        };
        rowData.on = {
          ...rowData.on,
          change: (e) => {
            console.log('大区选择', e);
            this.setValue({
              regionName: { regionName: e.regionName, regionCode: e.regionCode },
              regionCode: e.regionCode,
            });
          },
        };
      }
      if (rowData.field === 'subCompanyName') {
        rowData.props = {
          ...item.props,
          getValue: (field) => this.getFieldValue(field),
          title: rowData.title,
        };
        rowData.on = {
          ...rowData.on,
          change: (e) => {
            console.log('分公司选择', e);
            this.setValue({
              subCompanyName: { subCompanyCode: e.subCompanyCode, subCompanyName: e.subCompanyName },
              subCompanyCode: e.subCompanyCode,
            });
          },
        };
      }
      if (rowData.field === 'dealerName') {
        rowData.props = {
          ...item.props,
          getValue: (field) => this.getFieldValue(field),
          title: rowData.title,
        };
        rowData.on = {
          ...rowData.on,
          change: (e) => {
            console.log('经销商选择', e);
            this.setValue({
              dealerName: { dealerCode: e.dealerCode, dealerName: e.dealerName },
              dealerCode: e.dealerCode,
            });
          },
        };
      }
      if (rowData.field === 'personPhone') {
        rowData.props = {
          ...item.props,
          maxlength: '11',
        };
        rowData.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: '^1[3-9][0-9]{9}$',
            message: '手机号格式不准确',
          },
        ];
      }
      if (rowData.field === 'yearTurnover') {
        rowData.props = {
          ...item.props,
        };
        rowData.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: '^[1-9][0-9]*$',
            message: '年营业额/万元为正整数',
          },
        ];
      }
      if (rowData.field === 'employeeNumber') {
        rowData.props = {
          ...item.props,
        };
        rowData.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: '^[1-9][0-9]*$',
            message: '员工人数为正整数',
          },
        ];
      }
      if (rowData.field === 'yearAlcoholTolerance') {
        rowData.props = {
          ...item.props,
        };
        rowData.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: '^[1-9][0-9]*$',
            message: '年用酒量/万元为正整数',
          },
        ];
      }
      return rowData;
    },
    // 渲染完成后执行
    formComplete() {
      this.judgeHidden();
      this.disabled(true, ['cityCode', 'districtCode']);
      const provinceCode = this.getRule('provinceCode');
      const cityCode = this.getRule('cityCode');
      const districtCode = this.getRule('districtCode');
      provinceCode.restful = '/mdm/mdmRegionController/selectStartWithProvince';
      provinceCode.optionsKey = { label: 'regionName', value: 'regionCode' };
      provinceCode.props.loading = true;
      provinceCode.props = {
        ...provinceCode.props,
        loading: true,
        filterable: true,
        remote: true,
        remoteParams: 'regionName',
      };

      provinceCode.on.change = (val) => {
        console.log('porr', val);
        console.log('provinceCode', provinceCode);

        this.setValue({
          city: '',
          district: '',
          province: provinceCode.options.find((pitem) => pitem.regionCode === val).regionName,
        });
        if (!val) {
          this.disabled(true, ['cityCode', 'districtCode']);
        } else {
          this.disabled(true, ['districtCode']);
          this.disabled(false, ['cityCode']);
        }
      };

      cityCode.restful = '/mdm/mdmRegionController/list';
      cityCode.optionsKey = { label: 'regionName', value: 'regionCode' };
      cityCode.restfulParamsGetValue = { parentCode: 'provinceCode' };
      cityCode.refresh = true;
      cityCode.props = {
        ...cityCode.props,
        loading: true,
        filterable: true,
        remote: true,
        remoteParams: 'regionName',
      };
      cityCode.on.change = (val) => {
        this.setValue({
          district: '',
          city: cityCode.options.find((pitem) => pitem.regionCode === val).regionName,
        });
        if (!val) {
          this.disabled(true, ['districtCode']);
        } else {
          this.disabled(false, ['districtCode']);
        }
      };
      districtCode.restful = '/mdm/mdmRegionController/list';
      districtCode.optionsKey = { label: 'regionName', value: 'regionCode' };
      districtCode.restfulParamsGetValue = { parentCode: 'cityCode' };
      districtCode.refresh = true;
      districtCode.props = {
        ...districtCode.props,
        loading: true,
        filterable: true,
        remote: true,
        remoteParams: 'regionName',
      };
      districtCode.on.change = (val) => {
        this.setValue({
          district: districtCode.options.find((pitem) => pitem.regionCode === val).regionName,
        });
      };

      // const qdDate = this.getRule('qdDate');
      // qdDate.props = {
      //   ...qdDate.props,
      //   pickerOptions,
      // };
      // const startTime = this.getRule('startTime');
      // startTime.props = {
      //   ...startTime.props,
      //   pickerOptions,
      // };
      // const endTime = this.getRule('endTime');
      // endTime.props = {
      //   ...endTime.props,
      //   pickerOptions,
      // };
      console.log('formConfig——————————', this.formConfig);
      const { code, row } = this.formConfig;
      if (code === 'view' || code === 'edit') {
        console.log(1111);
        request.post('/tpm/personprofile/query', {
          id: row.id,
        }).then((res) => {
          if (res.success) {
            console.log('接口返回', res);
            // let contAmount = 0;
            const { result } = res;
            this.setValue({
              ...result,
              regionName: { regionName: result.regionName, regionCode: result.regionCode },
              subCompanyName: { subCompanyCode: result.subCompanyCode, subCompanyName: result.subCompanyName },
              dealerName: { dealerCode: result.dealerCode, dealerName: result.dealerName },
            });
            this.judgeHidden(result.personType);
          }
        });
      }
    },
    judgeHidden(type) {
      const t2 = this.getRule('t2');
      const companyName = this.getRule('companyName');
      const companyAddress = this.getRule('companyAddress');
      if (type === '1') {
        this.hiddenFields(false, ['t2', 'companyName', 'companyType', 'yearTurnover', 'employeeNumber', 'yearAlcoholTolerance', 'provinceCode', 'cityCode', 'districtCode', 'companyAddress']);
        this.hiddenFields(true, ['industry', 'productList']);
        t2.props.title = '企业信息';
        companyName.title = '企业名称';
        companyAddress.title = '企业地址';
        companyAddress.props.placeholder = '企业地址';
        companyName.props.placeholder = '企业名称';
        this.setValue({
          industry: null,
          productList: [],
        });
      } else if (type === '2') {
        this.hiddenFields(false, ['t2', 'companyName', 'industry', 'provinceCode', 'cityCode', 'districtCode', 'companyAddress', 'productList']);
        this.hiddenFields(true, ['companyType', 'yearTurnover', 'employeeNumber', 'yearAlcoholTolerance']);
        t2.props.title = '单位信息';
        companyName.title = '单位名称';
        companyAddress.title = '单位地址';
        companyAddress.props.placeholder = '单位地址';
        companyName.props.placeholder = '单位名称';
        this.setValue({
          companyType: null,
          yearTurnover: null,
          employeeNumber: null,
          yearAlcoholTolerance: null,
        });
      } else if (type === '3') {
        this.hiddenFields(false, ['t2', 'companyName', 'provinceCode', 'cityCode', 'districtCode', 'companyAddress']);
        this.hiddenFields(true, ['industry', 'companyType', 'yearTurnover', 'employeeNumber', 'yearAlcoholTolerance', 'productList']);
        t2.props.title = '单位信息';
        companyName.title = '单位名称';
        companyAddress.title = '单位地址';
        companyAddress.props.placeholder = '单位地址';
        companyName.props.placeholder = '单位名称';
        this.setValue({
          industry: null,
          companyType: null,
          yearTurnover: null,
          employeeNumber: null,
          yearAlcoholTolerance: null,
        });
      } else {
        this.hiddenFields(true, ['t2', 'companyName', 'companyType', 'yearTurnover', 'employeeNumber', 'yearAlcoholTolerance', 'provinceCode', 'cityCode', 'districtCode', 'companyAddress', 'productList', 'industry']);
      }
    },

    submit(btn) {
      console.log(btn);
      const params = this.getFormData();
      console.log(params);
      const dealerNameAgr = params.dealerName ? params.dealerName.dealerName : '';
      const regionNameAgr = params.regionName ? params.regionName.regionName : '';
      const subCompanyNameAgr = params.subCompanyName ? params.subCompanyName.subCompanyName : '';
      const pars = {
        ...params,
        // cusName: params.cusName.customerName,
        zcFlag: 'N',
        id: this.formConfig.id || '',
        dealerName: dealerNameAgr,
        regionName: regionNameAgr,
        subCompanyName: subCompanyNameAgr,
      };
      console.log('pars', pars);
      // if (!params.details) {
      //   this.$message.error('请选择可购商品');
      //   return false;
      // }
      if (btn === 2) {
        pars.zcFlag = 'Y';
      }
      // if (params.details && params.details.length > 0) {
      //   params.details.map((i) => {
      //     const arr = [];
      //     if (Array.isArray(i.saleArea)) {
      //       i.saleArea.map((item) => {
      //         arr.push(item.join('/'));
      //         return item;
      //       });
      //       i.saleArea = arr.join(',');
      //     }
      //     return i;
      //   });
      // }
      console.log(params);
      if (params) {
        let path = '';
        if (this.formConfig.id) {
          path = '/tpm/personprofile/update';
        } else {
          path = '/tpm/personprofile/save';
        }
        request.post(path, pars).then((res) => {
          if (res.code === 200) {
            this.$message.success('操作成功！');
            this.$emit('onClose');
            this.$emit('onGetList');
          } else {
            this.$message.error(res.messge);
          }
        });
      }
    },
  },
};
